// extracted by mini-css-extract-plugin
module.exports = {"tabs":"navigation-tabs_tabs__ZP0Y1","tab":"navigation-tabs_tab__FOOI1","tab-text":"navigation-tabs_tab-text__vBoPn","active":"navigation-tabs_active__VXDFO"};